import { Repository, Structures } from '@clavisco/core';
import { environment } from 'src/environments/environment';
import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { LinkerService } from '@clavisco/linker';
import { AppSettings, Settings } from "./app.settings";
import { Login } from "@clavisco/login";
import { IToken } from './core/interfaces/i-token';
import * as LogRocket from 'logrocket';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'CL_AE_FCG_MGY';
  loading: boolean = false;
  public settings: Settings;
  currentUser!: IToken;

  constructor(
    @Inject('LinkerService') private linkerService: LinkerService,
    public appSettings: AppSettings,
    private cdr: ChangeDetectorRef
  ) {
    this.settings = this.appSettings.settings;
    if (environment.production) {
      if (environment.LogRocketId) {
        LogRocket.init(environment.LogRocketId);
      }
    }
  }

  ngOnInit(): void {
    Repository.Behavior.SetTokenConfiguration({
      token: 'Shared',
      setting: 'apiUrl',
      value: environment.ApiAppUrl,
    });

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.LOGN,
      setting: 'overlaysConfiguration',
      value: JSON.stringify({
        loginMessage: 'Procesando, espere por favor',
        changePasswordMessage: 'Cambiando Contraseña',
        sendRecoverEmailMessage: 'Enviando Correo de Recuperación',
        recoverPasswordMessage: 'Actualizando Contraseña',
      } as Login.Structures.IOverlaysGlobalConfiguration),
    });

    Repository.Behavior.SetTokenConfiguration({
      token: `Alerts`, // Identificador que va a guardar nuestras configuraciones, este se indica al inicio del documento
      settings: {
        toastDuration: 10000, // Tiempo que va a ser mostrada nuestra alerta en pantalla
        verticalPosition: 'top', // Posicón en vertical de la alerta, posible valores: ['top', 'bottom']
        horizontalPosition: 'right', // Posición horizontal de la alerta, posible valores :['start','center','end','left','right']
        darkMode: true, // Tema de la alerta, claro o oscuro
        defaultCloseText: `Close`, // Texto que va a tener el botón de cerrar de la alerta
      },
      override:
        true /*Cuando está en true reemplaza todas las configuraciones viejas de este componente con las nuevas y cuando está en false solo actualiza las configuraciones que le indiquemos*/,
    });

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.LOGN,
      setting: 'sendRecoverPasswordEmail',
      value: {
        urlVariableToReplaceWithEmail: '#EMAIL', // Variable que se utilizara para agregar el correo del usuario
        endpointToRequest: `api/Account/RecoverPassword/#EMAIL`, // Endpoint para solicitar correo de recuperacion de contraseña
      } as Login.Structures.ISendRecoverPasswordEmailConfig,
    });

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.LOGN,
      setting: 'recoverPassword',
      value: {
        endpointToRequest: `api/Account/ChangeRecoverPassword`,
      } as Login.Structures.IChangePasswordConfig,
    });

    Repository.Behavior.SetTokenConfiguration({
      token: Structures.Enums.TOKENS.LOGN,
      setting: 'changePassword',
      value: {
        endpointToRequest: `api/Account/ChangePassword`,
      } as Login.Structures.IChangePasswordConfig,
    });

    this.cdr.detectChanges();
  }
}
